import { CSSProperties } from 'react'
import { DataSourceItem } from './convert-calculations-to-data-source'
import isCalculation from './is-calculation'

type CSSPropertiesWithVars = CSSProperties & Record<string, string | number | undefined>

export const getRowClassName = (record: DataSourceItem) =>
    isCalculation(record)
        ? 'calculation-table-row calculation-table-row--calculation'
        : 'calculation-table-row calculation-table-row--position'

export const getRowStyle = (record: DataSourceItem): CSSPropertiesWithVars | undefined => {
    if (isCalculation(record) || !record.uiColor) {
        return undefined
    }

    return {
        '--calculation-row-color': record.uiColor,
    }
}

